<template>
  <section class="cms-body">
    <el-form
      ref="form"
      :model="dataInfo"
      :rules="rules"
      class="cms-form"
      label-width="162px"
    >
      <el-form-item label="设备标识" class="flex-50">
        {{ dataInfo.guid }}
      </el-form-item>
      <el-form-item label="报警名称" class="flex-50" prop="alarm_name">
        <el-input v-model="dataInfo.alarm_name"></el-input>
      </el-form-item>

      <el-form-item label="报警编号" class="flex-50" prop="alarm_code">
        <el-input v-model="dataInfo.alarm_code"></el-input>
      </el-form-item>
      <el-form-item label="报警类型" class="flex-50" prop="atid">
        <el-select
          v-model="dataInfo.atid"
          placeholder="请选择"
          @change="alarmChange"
        >
          <el-option
            v-for="(item, index) in alarmTypes"
            :key="item.atid"
            :label="index + 1 + '-' + item.at_name + '报警'"
            :value="item.atid"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-show="dataInfo.atid"
        label="设备变量"
        class="flex-50"
        prop="vcid"
      >
        <el-select
          v-model="dataInfo.vcid"
          placeholder="请选择"
          @change="varChange"
        >
          <el-option
            v-for="item in vars"
            :key="item.vcid"
            :label="item.var_name + '-' + item.var_code"
            :value="item.vcid"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-show="varType === '1' && dataInfo.atid && dataInfo.atid < 8"
        label="报警值X"
        prop="triggerX"
        class="flex-50"
      >
        <el-input v-model="triggerX" placeholder="0-65535"></el-input>
      </el-form-item>
      <el-form-item
        v-show="varType === '1' && dataInfo.atid && dataInfo.atid < 8"
        prop="isContainX"
        label="是否包含报警值X"
        class="flex-50"
      >
        <el-radio-group v-model="isContainX">
          <el-radio :label="'0'">否</el-radio>
          <el-radio :label="'1'">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        v-show="varType === '1' && dataInfo.atid && dataInfo.atid === 3"
        label="报警值Y"
        prop="triggerY"
        class="flex-50"
      >
        <el-input v-model="dataInfo.triggerY" placeholder="0-65535"></el-input>
      </el-form-item>
      <el-form-item
        v-show="varType === '1' && dataInfo.atid && dataInfo.atid === 3"
        prop="isContainY"
        label="是否包含报警值Y"
        class="flex-50"
      >
        <el-radio-group v-model="isContainY">
          <el-radio :label="'0'">否</el-radio>
          <el-radio :label="'1'">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="报警延迟[S秒]" prop="alarm_delay" class="flex-50">
        <el-input v-model="dataInfo.alarm_delay">
          <template slot="append">s</template>
        </el-input>
      </el-form-item>

      <el-form-item label="图标" class="flex-50">
        <cmsPicture
          :picurl="picUrl"
          :showcancel="showCancel"
          @btnClick="openPicDiag()"
          @picCancel="picCancel()"
          @picReset="picCancel()"
        ></cmsPicture>
      </el-form-item>
      <el-form-item label="报警联系人" class="flex-50" prop="mobiles">
        <div>
          <el-tag
            :key="tag.id"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag.label }}
          </el-tag>
          <el-button class="button-new-tag" size="small" @click="showDiag()"
            >+ 通知联系人</el-button
          >
        </div>
      </el-form-item>

      <el-form-item label="报警规则" class="flex-50" prop="alarm_rule">
        <el-input
          type="textarea"
          v-model="dataInfo.alarm_rule"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" class="flex-50">
        <el-input
          type="textarea"
          v-model="dataInfo.alarm_des"
          :rows="5"
        ></el-input>
      </el-form-item>

      <!-- 按钮组 -->
      <div class="form-footer">
        <el-button type="warning" @click="add(true)">保存并继续添加</el-button>
        <el-button type="primary" @click="add(false)">提交</el-button>
        <el-button type="info" @click="reset">重置</el-button>
        <el-button type="info" @click="$router.go(-1)">返回</el-button>
        <span class="gray">
          选择“提交并继续添加”按钮会停留在添加页面；选择“提交”按钮后将跳转到对应的列表页</span
        >
      </div>
    </el-form>

    <!-- 图片选择 -->
    <el-dialog title="图片选择" :visible.sync="picDialog">
      <cmsPictureList
        :total="total"
        :tableData="tableData"
        @picClick="picClick"
        @change="getPages"
      ></cmsPictureList>
    </el-dialog>
    <!-- 联系人选择 -->
    <el-dialog title="添加联系人" width="50%" :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="联系人" placeholder="请选择联系人" required>
          <el-select
            v-model="form.contact_name"
            @change="contactChange"
            style="width:100%;"
          >
            <template v-for="(item, index) in contacts">
              <el-option
                v-if="contactIds.indexOf(item.cid) === -1"
                :key="'contact' + item.cid"
                :value="index"
                :label="item.contact_name + '[' + item.contact_mobile + ']'"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="通知方式" required>
          <el-select
            v-model="form.contact_inform"
            placeholder="请选择通知方式"
            style="width:100%;"
          >
            <el-option label="短信" value="0"></el-option>
            <el-option label="语音" value="1"></el-option>
            <el-option label="全部" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleContacts()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import va from "@/rules";
import formMixns from "@/mixins/form";
import listMixins from "@/mixins/list";

export default {
  mixins: [formMixns, listMixins], //普通表单变量
  data() {
    let self = this;
    let required = va.required("此项必填");
    let number = va.number("只能输入数字");
    let double = va.double("只能输入数字或小数");
    let codeExist = va.validateCode("报警类型已存在", "Alarm/IsExist", "");
    return {
      rules: {
        // 校验规则
        alarm_name: [required],
        alarm_code: [required, codeExist],
        alarm_delay: [required, number],
        atid: [required],
        vcid: [required],
        guid: [required],
        alarm_rule: [required],
        triggerX: [double],
        triggerY: [],
        isContainX: [number],
        isContainY: [number]
      },
      vars: [],
      varType: "0",
      alarmTypes: [], //报警类型
      triggerX: "0",
      isContainX: "0",
      triggerY: "0",
      isContainY: "0",
      isIndeterminate: true,
      checkList: [],
      contacts: [], //联系人数组
      dynamicTags: [],
      contactIds: [], //判断是否重复添加联系人
      dialogVisible: false,
      form: {
        id: 0,
        contact_name: "",
        contact_inform: ""
      },
      containLable: "", //iscontain字段的label
      params: {
        pageNo: "1",
        pageSize: "10",
        uid: ""
      },
      picDialog: false,
      picUrl: "",
      showCancel: false
    };
  },
  methods: {
    add(state) {
      //自定义一下处理方法
      if (this.dataInfo.mobiles != null && this.dataInfo.mobiles != "") {
        let strs = this.dataInfo.mobiles.split(","); //字符分割
        if (strs.length > 10) {
          this.$alert("最多可输入10个可接收报警手机号");
          return;
        }
      }
      if (this.dataInfo.atid < 8) {
        if (this.dataInfo.atid === 3) {
          this.dataInfo.trigger_val = this.triggerX + "," + this.triggerY;
          this.datainfo.isContain = this.isContainX + "," + this.isContainY;
        } else {
          this.dataInfo.trigger_val = this.triggerX;
          this.datainfo.isContain = this.isContainX;
        }
      }

      this.saveDataInfo(
        state,
        "Alarm/Insert",
        this.dataInfo,
        "/alarm/list?id=" + this.dataInfo.guid
      );
    },
    reset() {
      this.dataInfo = {
        guid: this.$route.query.guid,
        alarm_contact: "",
        alarm_inform: ""
      };
    },
    loadOptions() {
      this.$api.post("VarConf", { guid: this.$route.query.guid }).then(res => {
        if (res.status === 200) {
          this.vars = res.data.Data.list;
        }
      });

      this.$api
        .post("Contacts", { uid: this.$store.state.userInfo.id })
        .then(res => {
          if (res.status === 200) {
            this.contacts = res.data.Data.list;
          }
        });

      this.$api.post("AlarmType").then(res => {
        if (res.status === 200) {
          this.alarmTypes = res.data.Data;
        }
      });
    },
    varChange(e) {
      var obj = this.vars.find(function(item) {
        return String(item.vcid) === String(e);
      });
      this.varType = obj.var_type;
    },
    alarmChange(e) {
      this.updateRules(e);
    },
    handleClose(tag) {
      let index = tag.index; //联系人索引
      let id = tag.id; //联系人id
      let cids = this.dataInfo.alarm_contact.split(",");
      let informs = this.dataInfo.alarm_inform.split(",");
      cids.splice(index, 1);
      informs.splice(index, 1);
      this.dataInfo.alarm_contact = cids.join(",");
      this.dataInfo.alarm_inform = informs.join(",");

      this.dynamicTags.splice(index, 1);
      //this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);

      let index1 = this.contactIds.indexOf(id);
      this.contactIds.splice(index1, 1);
    },
    showDiag() {
      this.dialogVisible = true; //此处打开dialog
      this.form.contact_name = "";
      this.form.contact_inform = "";
    },
    handleContacts() {
      this.dialogVisible = false;
      let inputValue = this.form.contact_name;
      if (inputValue) {
        //1.存入数据库
        if (this.dataInfo.alarm_contact) {
          this.dataInfo.alarm_contact += ",";
        } else {
          this.dataInfo.alarm_contact = "";
        }
        if (this.dataInfo.alarm_inform) {
          this.dataInfo.alarm_inform += ",";
        } else {
          this.dataInfo.alarm_inform = "";
        }

        this.dataInfo.alarm_contact += this.form.id;
        this.dataInfo.alarm_inform += this.form.contact_inform;
        //2.展示到tag
        this.dynamicTags.push({
          index: this.dynamicTags.length,
          id: this.form.id,
          label: inputValue
        });
        this.contactIds.push(this.form.id);
      }
    },
    contactChange(e) {
      let index = e; //当前联系人的索引值
      this.form.id = this.contacts[index].cid;
      this.form.contact_name =
        this.contacts[index].contact_name +
        "[" +
        this.contacts[index].contact_mobile +
        "]";
    },
    openPicDiag() {
      this.picDialog = true;
    },
    picClick(id, url) {
      this.dataInfo.tpid = id;
      this.picUrl = url;
      this.showCancel = true;
    },
    picCancel() {
      this.dataInfo.tpid = null;
      this.picUrl = "";
      this.showCancel = false;
    },
    resetRules() {
      // 校验规则复位
      let required = va.required("此项必填");
      let number = va.number("只能输入数字");
      let double = va.double("只能输入数字或小数");
      this.rules.vcid = [number];
      this.rules.alarm_rule = [required];
      this.rules.triggerX = [double];
      this.rules.triggerY = [double];
      this.rules.isContainX = [number];
      this.rules.isContainY = [number];
    },
    updateRules(e) {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

      let required = va.required("此项必填");
      let number = va.number("只能输入数字");
      let double = va.double("只能输入数字或小数");
      this.resetRules();
      switch (e) {
        case 1:
        case 2:
        case 6:
        case 7: //需要变量验证；X约束为小数，不约束Y
          this.rules.vcid = [required, number];
          this.rules.triggerX = [required, double];
          this.rules.isContainX = [required, number];
          break;
        case 3: //需要变量验证；X，Y均约束为小数
          this.rules.vcid = [required, number];
          this.rules.triggerX = [required, double];
          this.rules.triggerY = [required, double];
          this.rules.isContainX = [required, number];
          this.rules.isContainY = [required, number];
          break;
        case 4:
        case 5: //需要变量验证；X约束为整数
          this.rules.vcid = [required, number];
          this.rules.triggerX = [required, number];
          this.rules.isContainX = [required, number];
          break;
        case 8:
        case 9: //需要变量验证
        case 10:
        case 11:
          this.rules.vcid = [required, number];
          break;
        default:
          //不需要变量验证
          this.rules.vcid = [number];
          break;
      }
    }
  },
  created() {
    //初始获取数据
    this.loadOptions();
    this.reset();
    //获取图片
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Picture/PagedView", this.params);
  }
};
</script>
